export interface BranchNameFields {
  show_name?: string
  show_name_en?: string
  show_name_cn?: string
  branch_name?: string
  branch_name_en?: string
  branch_name_cn?: string
}

export function getBranchDisplayNamei18n(branch: BranchNameFields, lang = 'th'): string {
  const th = branch.show_name ?? branch.branch_name ?? ''
  const en = branch.show_name_en ?? branch.branch_name_en ?? th
  const cn = branch.show_name_cn ?? branch.branch_name_cn ?? en

  if (lang === 'cn') return cn
  if (lang === 'en') return en
  return th
}
